import { api } from '../main-api/apiClient';

// System Admin Tenant Management
export const systemAdminAPI = {
  // Tenant Management
  getAllTenants: () => {
    console.log('=== FRONTEND: systemAdminAPI.getAllTenants called ===');
    return api.get('/system-admin/tenants');
  },
  getTenant: (tenantId) => {
    console.log(`=== FRONTEND: systemAdminAPI.getTenant called with tenantId=${tenantId} ===`);
    return api.get(`/system-admin/tenants/${tenantId}`);
  },
  
  createTenant: (tenantData, logoFile = null) => {
    console.log('=== FRONTEND: systemAdminAPI.createTenant called ===');
    console.log('Tenant data:', tenantData);
    console.log('Logo file:', logoFile ? logoFile.name : 'None');
    
    try {
      const formData = new FormData();
      Object.keys(tenantData).forEach(key => {
        if (tenantData[key] !== null && tenantData[key] !== undefined && tenantData[key] !== '') {
          formData.append(key, tenantData[key]);
        }
      });
      
      // Add logo file if provided
      if (logoFile) {
        formData.append('logo_file', logoFile);
        console.log('Logo file added to form data:', logoFile.name);
      }
      
      console.log('Form data prepared, making API call...');
      return api.post('/system-admin/tenants', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      console.error('=== FRONTEND: systemAdminAPI.createTenant failed ===');
      console.error('Error:', error);
      console.error('Tenant data:', tenantData);
      throw error;
    }
  },
  
  updateTenant: (tenantId, tenantData, logoFile = null) => {
    console.log('=== FRONTEND: systemAdminAPI.updateTenant called ===');
    console.log('Tenant ID:', tenantId);
    console.log('Tenant data:', tenantData);
    console.log('Logo file:', logoFile ? logoFile.name : 'None');
    
    try {
      const formData = new FormData();
      Object.keys(tenantData).forEach(key => {
        if (key !== 'tenant_id' && tenantData[key] !== null && tenantData[key] !== undefined && tenantData[key] !== '') {
          formData.append(key, tenantData[key]);
        }
      });
      
      // Add logo file if provided
      if (logoFile) {
        formData.append('logo_file', logoFile);
        console.log('Logo file added to form data:', logoFile.name);
      }
      
      console.log('Form data prepared, making API call...');
      return api.put(`/system-admin/tenants/${tenantId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      console.error('=== FRONTEND: systemAdminAPI.updateTenant failed ===');
      console.error('Error:', error);
      console.error('Tenant ID:', tenantId);
      console.error('Tenant data:', tenantData);
      throw error;
    }
  },
  
  // Legacy APIs for backward compatibility (keeping the full paths)
  getAllTenantsLegacy: () => api.get('/admin/tenants'),
  createTenantLegacy: (tenantData) => {
    const formData = new FormData();
    Object.keys(tenantData).forEach(key => {
      if (tenantData[key] !== null && tenantData[key] !== undefined && tenantData[key] !== '') {
        formData.append(key, tenantData[key]);
      }
    });
    return api.post('/admin/tenants', formData);
  },
  
  // System Statistics
  getSystemStatistics: () => api.get('/system-admin/statistics'),
  
  // ✅ FIXED: Dashboard APIs now use correct system-admin endpoints
  getDashboardStats: () => api.get('/system-admin/dashboard/stats'),
  getRecentActivity: (limit = 10) => api.get(`/system-admin/dashboard/recent-activity?limit=${limit}`),
  
  // User Management (correct endpoints)
  getAllUsers: (page = 1, pageSize = 10, search = '', role = '', tenantId = '', status = '') => {
    console.log('=== FRONTEND: systemAdminAPI.getAllUsers called ===');
    console.log(`Parameters: page=${page}, pageSize=${pageSize}, search=${search}, role=${role}, tenantId=${tenantId}, status=${status}`);
    
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('page_size', pageSize.toString());
    
    if (search) params.append('search', search);
    if (role) params.append('role', role);
    if (tenantId) params.append('tenant_id', tenantId);
    if (status) params.append('status', status);
    
    const url = `/system-admin/users?${params.toString()}`;
    console.log(`Making API call to: ${url}`);
    return api.get(url);
  },
  
  // New hybrid Auth0 user management endpoints
  createUser: (userData) => {
    console.log('=== FRONTEND: systemAdminAPI.createUser called ===');
    console.log('User data:', userData);
    
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        formData.append(key, userData[key]);
      }
    });
    
    console.log('FormData contents:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    
    return api.post('/system-admin/users/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  updateUser: (userId, userData) => {
    console.log(`=== FRONTEND: systemAdminAPI.updateUser called with userId=${userId} ===`);
    console.log('User data:', userData);
    
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined && userData[key] !== '') {
        formData.append(key, userData[key]);
      }
    });
    
    console.log('FormData contents:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    
    return api.put(`/system-admin/users/${userId}/update`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  deleteUser: (userId) => {
    return api.delete(`/system-admin/users/${userId}`);
  },
  
  // MFA Management
  sendMfaEnrollment: (userId) => {
    console.log(`=== FRONTEND: systemAdminAPI.sendMfaEnrollment called with userId=${userId} ===`);
    return api.post(`/system-admin/users/${userId}/send-mfa-enrollment`);
  },
  
  resendPasswordSetup: (userId) => {
    console.log(`=== FRONTEND: systemAdminAPI.resendPasswordSetup called with userId=${userId} ===`);
    return api.post(`/system-admin/users/${userId}/resend-password-setup`);
  },
  
  // Question Management
  getAllQuestions: () => api.get('/system-admin/questions'),
  createQuestion: (questionData) => api.post('/system-admin/questions', questionData),
  updateQuestion: (questionId, questionData) => api.put(`/system-admin/questions/${questionId}`, questionData),
  deleteQuestion: (questionId) => api.delete(`/system-admin/questions/${questionId}`),
  
  // Configuration Management
  getSystemConfig: () => api.get('/system-admin/config'),
  updateSystemConfig: (configData) => api.put('/system-admin/config', configData),
  
  // Patient Overview
  getGlobalPatientStats: () => api.get('/system-admin/patients/statistics'),
  
  // System Health
  getSystemHealth: () => api.get('/system-admin/health'),
  
  // Activity Logs
  getActivityLogs: (limit = 50, offset = 0) => api.get(`/system-admin/activity-logs?limit=${limit}&offset=${offset}`),
  
  // Performance Metrics
  getPerformanceMetrics: () => api.get('/system-admin/performance'),
  
  // Security Status
  getSecurityStatus: () => api.get('/system-admin/security/status'),
  
  // Maintenance Operations
  runMaintenanceTask: (taskType) => api.post('/system-admin/maintenance/run', { task_type: taskType }),
  
  // Backup Operations
  createBackup: () => api.post('/system-admin/backup/create'),
  getBackupStatus: (backupId) => api.get(`/system-admin/backup/${backupId}/status`),
  
  // System Updates
  checkForUpdates: () => api.get('/system-admin/updates/check'),
  applyUpdate: (updateId) => api.post(`/system-admin/updates/${updateId}/apply`),
  
  // Monitoring and Alerts
  getSystemAlerts: () => api.get('/system-admin/alerts'),
  acknowledgeAlert: (alertId) => api.put(`/system-admin/alerts/${alertId}/acknowledge`),
  
  // Audit Logs
  getAuditLogs: (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    return api.get(`/system-admin/audit-logs?${params.toString()}`);
  },
  
  // Data Export
  exportData: (dataType, format = 'json') => api.get(`/system-admin/export/${dataType}?format=${format}`),
  
  // System Reports
  generateReport: (reportType, params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    return api.post(`/system-admin/reports/${reportType}?${queryParams.toString()}`);
  }
};